import { useGraphqlDelete } from "@mzara/component";

export const useDeleteAppointmentMutation = () => {
    return useGraphqlDelete('appointment')
};
